// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "c083e077",
    "hash": "c083e077",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c083e077",
    "semverString": null,
    "version": "2026.8.0.5"
};
/* tslint:enable */
